import { ValidationItems } from '@kanda-libs/ks-component-ts';
import { FinanceProvider, FinanceType } from '@kanda-libs/ks-frontend-services';

export const DECLINE_QUOTE_MODAL_ID = 'decline-quote-modal';

export const REQUEST_VALIDATION: ValidationItems = {
  required: { value: true, message: 'Please provide a decline request.' },
};

export const DECLINE_FINANCE_OPTION = {
  name: 'decline',
  fee: 0,
  charge: 0,
  enabled: true,
  finance_types: ['primary'] as FinanceType[],
  provider: 'demo' as FinanceProvider,
};

export type Option = {
  id: string;
  text: string;
};

export const OPTIONS: Option[] = [
  {
    id: 'not-proceeding',
    text: "I'm no longer proceeding with the work",
  },
  {
    id: 'not-interested-in-finance',
    text: "I'm no longer interested in finance",
  },
  {
    id: 'another-tradesperson',
    text: 'My work is being done by another tradesperson',
  },
  {
    id: 'other',
    text: '',
  },
];
